import { FormField, Input } from '@wix/design-system';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../ricos-context';
import { isValidUrl } from './../../_shared/link/is-valid-url';

import type { LinkSettingsValue } from '../link-settings/link-settings';

type Status = 'OK' | 'ERROR';

type LinkInputProps = {
  value: string;
  onChange: (url: string | undefined, status: Status) => void;
  placeholder: string;
  dataHook: string;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  onBlur?: (url: LinkSettingsValue, status: Status) => void;
  allowTelLink?: boolean;
  labelEnabled?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export const LinkInput: React.FC<LinkInputProps> = ({
  value,
  onChange,
  placeholder,
  dataHook,
  inputRef,
  onBlur,
  allowTelLink,
  labelEnabled = true,
  size = 'medium',
}) => {
  const [state, setState] = useState<Status>(() =>
    value && !isValidUrl(value, { allowTelLink }) ? 'ERROR' : 'OK'
  );
  const { t } = useContext(RicosContext);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setState('OK');
    onChange(value, 'OK');
  };

  const handleBlur = () => {
    if (value && !isValidUrl(value, { allowTelLink })) {
      setState('ERROR');
    }

    const status = value && !isValidUrl(value, { allowTelLink }) ? 'ERROR' : 'OK';
    setState(status);

    onBlur?.({ url: value }, status);
  };

  return (
    <FormField
      status={state === 'ERROR' ? 'error' : undefined}
      statusMessage={state === 'ERROR' ? t('LinkPanel_ErrorTooltip') : undefined}
      label={labelEnabled ? t('GalleryImageSettings_Link_Label') : undefined}
    >
      <Input
        size={size}
        inputRef={ref => {
          if (inputRef) {
            inputRef.current = ref;
          }
        }}
        type="url"
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        dataHook={dataHook}
        onBlur={handleBlur}
      />
    </FormField>
  );
};
